import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import listBcAlert from 'src/app/core/constants/bc-alert-messages/bc-alert-messages.json';
import listLogMessages from 'src/app/core/constants/transaction-log-messages/transaction-log-messages.json';
import { SpinnerService } from 'src/app/shared/commons/spinner/service/spinner.service';
import { Errors } from '@azure/msal-common';
import { BcDialogService } from '@bancolombia/design-system-web/bc-services';
import { BcAlertComponent } from '@bancolombia/design-system-web/bc-alert';
import { Router } from '@angular/router';
import { PolicyService } from 'src/app/core/services/shared/policy.service';
import { CacheService } from 'src/app/core/services/shared/cache.service';
import { StorageService } from 'src/app/core/services/helpers/storage.service';
import { BcInputTokenComponent } from '@bancolombia/design-system-web/bc-input-token';

@Component({
  selector: 'app-validate-otp',
  templateUrl: './validate-otp.component.html',
  styleUrls: ['./validate-otp.component.css']
})
export class ValidateOtpComponent implements OnInit, AfterViewInit {
  @ViewChild(BcInputTokenComponent, { static: false })
  token!: BcInputTokenComponent;
  formValidateOtp: FormGroup;

  maxTry: number = 3;
  currentTry: number = 1;

  resendOtpCount: number = 1;
  resendOtpMax: number = 3;

  restartCount = false;

  submit: boolean = true;
  totalTime: number = 120;

  listBcAlert: any = listBcAlert;
  listLogMessages: any = listLogMessages;

  errorSubtitle: string;
  errorTitle: string;
  exitMsg: string;

  textButtonRight: string;
  notTry: boolean = false;

  policyScreen = false;
  errorScreen = false;

  lastCall = null;

  @Input()
  textModal: string = "Código 409"
  @Input()
  titleModal: string = "Superaste el limite de intentos fallidos"

  @Input()
  titleImageSrc: string = "../../../../../assets/img/AuthLogo.png"

  @Input()
  titleText: string = "Comprueba tu identidad"

  @Input()
  subTitle: string = "Ingresa el código que te enviamos a tu celular"

  @Input()
  textButton: string = "Continuar"

  @Input()
  auth: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private spinnerSvc: SpinnerService,
    private dialogService: BcDialogService,
    private _cacheService: CacheService,
    private _policyService: PolicyService,
    private router: Router,
    private _storageService: StorageService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.errorSubtitle = this.listBcAlert.errorCodeOTP;
    this.errorTitle = this.listBcAlert.errorNewCodeTitle;

    this.textButtonRight = "Recibir un nuevo código";

    this.exitMsg = this.auth ? "Finalizar" : "Salir"
  }

  ngAfterViewInit() {
    const inputs: NodeListOf<HTMLInputElement> =
      this.token.bcInputToken.nativeElement.querySelectorAll('input');

    inputs.forEach((inp, index) => {
      // Configurar teclado numérico + ocultar
      inp.setAttribute('inputmode', 'numeric');
      inp.setAttribute('type', 'password');
      inp.setAttribute('maxlength', '1'); // IMPORTANTE
      inp.setAttribute('autocomplete', 'one-time-code');

      // Listener para avanzar automáticamente
      inp.addEventListener('input', () => {
        if (inp.value && index < inputs.length - 1) {
          inputs[index + 1].focus();
        }
      });

      // Listener para retroceder al borrar
      inp.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Backspace' && !inp.value && index > 0) {
          inputs[index - 1].focus();
        }
      });
    });
  }

  open(type, text, title): void {
    this.dialogService.open(BcAlertComponent, {
      id: 'alertOtp',
      type: type,
      text: text,
      title: title,
      dismissible: true,
      timeout: 5000,
    });
  }

  private buildForm(): void {
    this.formValidateOtp = this.formBuilder.group({
      otpCode: ['', [
        Validators.required
      ]]
    });
  }

  generateOtp() {
    this._policyService.generateOtp().then((response) => {
    }).catch((err: any) => {
      const msgError = err.error.errors ? err.error.errors[0] : this.listBcAlert.errorGenerateCode
      this.open("error", msgError, this.listBcAlert.errorNewCodeTitle);
    }).finally(() => {
      this.spinnerSvc.hide();
    })
  }

  resendOtp() {
    const timeOut = 2000;

    if (this.resendOtpCount >= this.resendOtpMax) {
      this.policyScreen = true;
      this.errorScreen = true;
    } else {
      this.resendOtpCount = this.resendOtpCount + 1;
      this.restartCount = true
      this.currentTry = 1;
      this.notTry = false;
      this.form.otpCode.reset()
      this.generateOtp();
      setTimeout(() => {
        this.restartCount = false
      }, timeOut);
    }
  }

  submitOtp(): void {
    this.submit = true

    const document = this._cacheService.get("documentClient");
    const documentType = this._cacheService.get("typeDocumentClient");
    const otpCode = this.formValidateOtp.value.otpCode;

    if (this.submit) {
      this.validateOtp(otpCode, document, documentType);
    }
  }

  validateOtp(otpCode: string, document: string, documentType: string) {
    this.spinnerSvc.show();
    const data = {
      securityCodeInformation: {
        securityCode: otpCode
      },
      identification: {
        type: documentType,
        number: document
      }
    }
    const log = {
      identificationNumber: document,
      identificationType: documentType,
      policyNumber: this._cacheService.get("policy")?.insurance_id || '',
      ipTransaction: this._cacheService.get('ip') || '',
      idSession: this._cacheService.get('idSession'),
      idRequest: 'validateOtp',
      description: listLogMessages.validateOtp
    }
    this._policyService.validateOtp({ data, log }).then((response: any) => {
      this.spinnerSvc.hide();
      if (!!response.data.securityCodeInformation.securityCode) {
        if (this.auth) {
          const info = response.data?.securityCodeInformation;
          this._storageService.setLocalStorage('otpValidation', JSON.stringify({
            securityCode: otpCode,
            document,
            documentType,
            transactionId: info.transactionId,
            expirationDate: info.expirationDate,
            remainingAttempts: info.remainingAttempts
          }))
          this.open("success", '', this.listBcAlert.validationSuccess);
          this.router.navigateByUrl('policy');
        } else {
          this.registerSignature();
        }
      }
    }).catch((err: any) => {
      this.spinnerSvc.hide();
      if (this.resendOtpCount >= this.resendOtpMax) {
        this.policyScreen = true;
        this.errorScreen = true;
        this.open("error", this.listBcAlert.errorCodeOTPTry, "Fallaste el ingreso 3 veces");
      } else {
        this.open("error", this.listBcAlert.errorCodeOTPTry, this.listBcAlert.errorCodeOTPTitleTry);
        this.addTry()
      }
    }).finally(() => {
      this.lastCall = this.submitOtp
    })
  }

  registerSignature() {
    this.spinnerSvc.show();
    const document = this._cacheService.get("documentClient");
    const documentType = this._cacheService.get("typeDocumentClient");
    const policyNumber = this._cacheService.get("policy")?.insurance_id;
    const otpCode = this.formValidateOtp.value.otpCode;

    const data = {
      customer: {
        identification: {
          type: documentType,
          number: document
        }
      },
      productAndSalesInformation: {
        policyNumber: policyNumber
      },
      securityCode: {
        OTP: otpCode
      }
    }

    const log = {
      identificationNumber: document,
      identificationType: documentType,
      policyNumber: this._cacheService.get("policy")?.insurance_id || '',
      ipTransaction: this._cacheService.get('ip') || '',
      idSession: this._cacheService.get('idSession'),
      idRequest: 'registerSignature',
      description: listLogMessages.validateOtpSign,
    }

    this._policyService.registerSignature({ data: { data }, log }).then((response: any) => {
      this.policyScreen = true;
      this.errorScreen = false;
      this.spinnerSvc.hide();
    }).catch((error: any) => {
      this.titleModal = "No fue posible realizar la firma";
      this.policyScreen = true;
      this.errorScreen = true;
      this.spinnerSvc.hide();
    }).finally(() => {
      this.lastCall = this.registerSignature
    })
  }

  addTry() {
    this.restartCount = false;
    if (this.currentTry < this.maxTry) {
      this.currentTry = this.currentTry + 1;
      this.form.otpCode.reset()
    }
    else {
      this.notTry = true;
    }
  }

  validateOtpForm(event) {
    if (!event) {
      this.form.otpCode.setErrors([
        Errors.INVALID_GRANT_ERROR
      ]);
    }
  }

  get form() {
    return this.formValidateOtp.controls;
  }

  retryLastCall() {
    this.lastCall();
  }

}
